const STORAGE_KEY = 'nexus:onboarding';

export interface OnboardingState {
  completedSteps: number[];
  dismissed: boolean;
}

const DEFAULT_STATE: OnboardingState = { completedSteps: [], dismissed: false };

export function getOnboardingState(): OnboardingState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_STATE };
    const parsed = JSON.parse(raw) as OnboardingState;
    return {
      completedSteps: Array.isArray(parsed.completedSteps) ? parsed.completedSteps : [],
      dismissed: !!parsed.dismissed,
    };
  } catch {
    return { ...DEFAULT_STATE };
  }
}

function saveState(state: OnboardingState) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function markStepComplete(step: number) {
  const state = getOnboardingState();
  if (!state.completedSteps.includes(step)) {
    state.completedSteps.push(step);
  }
  saveState(state);
}

export function dismissOnboarding() {
  const state = getOnboardingState();
  state.dismissed = true;
  saveState(state);
}

export function isOnboardingVisible(): boolean {
  const state = getOnboardingState();
  return !state.dismissed && state.completedSteps.length < 7;
}
